import React from "react";

import "./Link.css";

export default function Link() {
  return (
    <div className="Link">
      <a href="https://github.com/Carefree-Carmander/weather-react">Open-source code</a> by Carmen Blow
    </div>
  );
}